import { useState, useEffect } from "react";
import styled from "styled-components";

import LabelSection from "src/components/core/LabelSection";
import { Black, White } from "src/styles/color";
import { hexToRgba } from "src/common/color";

import EditIcon from "@mui/icons-material/Edit";
import Button from "src/components/core/Button";

import BlogSuggestionAddDialog from "./BlogSuggestionAddDialog";
import { useDialog } from "src/context/DialogContext";

import BlogCard from "src/components/blog/BlogCard";

import { getBlogSuggest } from "src/api/landingPage";

const S = {};

S.BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: ${White};
  box-shadow: 0px 4px 20px ${hexToRgba(Black, 0.1)};
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

S.BlogSuggestionContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  overflow-x: auto;
`;

S.BlogCard = styled(BlogCard)`
  cursor: pointer;
  width: 250px;
`;

export const MAX_BLOG_SUGGESTION = 6;

const BlogSuggestion = () => {
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const [blogSuggestion, setBlogSuggestion] = useState([]);

  const fetchBlogSuggest = async () => {
    try {
      const result = await getBlogSuggest();
      setBlogSuggestion(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchBlogSuggest();
  }, []);

  return (
    <S.BoxWrapper>
      <LabelSection
        title="บทความ"
        description={`บทความ ${blogSuggestion.length}/${MAX_BLOG_SUGGESTION} รายการ`}
        actionMenu={() => (
          <Button
            startIcon={<EditIcon />}
            variant="secondary"
            size="large"
            sx={{
              minWidth: 200,
            }}
            onClick={() => {
              openDialog({
                type: "custom",
                customDialog: (
                  <BlogSuggestionAddDialog
                    onClose={() => closeDialog()}
                    onSuccess={async () => {
                      closeAllDialogs();
                      await fetchBlogSuggest();
                    }}
                  />
                ),
              });
            }}
          >
            แก้ไข
          </Button>
        )}
      >
        <S.BlogSuggestionContainer>
          {blogSuggestion.map((blog, index) => (
            <S.BlogCard
              key={index}
              title={blog.title}
              excerpt={blog.sub_title}
              tags={blog?.hashtags.slice(0, 3)}
              image={blog.preview_image}
            />
          ))}
        </S.BlogSuggestionContainer>
      </LabelSection>
    </S.BoxWrapper>
  );
};

export default BlogSuggestion;
